import React from "react";
import { Button, type ButtonProps } from "@chakra-ui/react";

type Props = {
  isActive: boolean;
  children: string;
} & ButtonProps;

export function SidebarButton({ isActive, children, ...props }: Props) {
  return (
    <Button data-active={isActive} variant="sidebar" {...props}>
      {children}
    </Button>
  );
}
